import React from 'react';
import { useSelector } from '../../hooks/useSelector';
import { createUseStyles } from '../../hooks/jss';

const useStyle = createUseStyles(() => ({
  container: {
    color: 'transparent',
    textAlign: 'end',
    fontSize: '9px'
  }
}));

export const BuildSHA = () => {
  const classes = useStyle();
  const sha = useSelector(state => state.environment.sha);

  return <div className={classes.container}>{sha}</div>;
};
